import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { ApiQaroniEnv } from '@qaroni-core/conf/apis/api-qaroni.config';
import { UserDTO } from '../types/account';
import { AccountApiObject } from '../types/account.response';
import { PasswordDTO } from '../types/change-password';

@Injectable({
  providedIn: 'root',
})
export class AccountHttpService {
  private http = inject(HttpClient);
  private readonly URLBase = ApiQaroniEnv.URLBase;

  public changePassword$(userID: number, passwordDTO: PasswordDTO) {
    const url = `${ApiQaroniEnv.URLBase}/admin/users/${userID}/passwords`;

    return this.http.patch<AccountApiObject>(url, passwordDTO);
  }

  public account$(userID: number) {
    const url = `${this.URLBase}/admin/users/${userID}`;

    return this.http.get<AccountApiObject>(url);
  }

  public accountUpdate$(userID: number, userDTO: UserDTO) {
    const url = `${ApiQaroniEnv.URLBase}/admin/users/${userID}`;

    return this.http.patch<AccountApiObject>(url, userDTO);
  }

  public deleteImage$(userID: number) {
    const url = `${ApiQaroniEnv.URLBase}/admin/users/${userID}/images`;

    return this.http.delete<AccountApiObject>(url);
  }
}
